export const commonMessages = {
  'card.addCart': '加入购物车',
  'card.added': '✓ 已加入',
  'card.avg': '均分',
  'card.dash': '—',
  'card.favFail': '收藏操作失败',
  'card.favorites': '收藏',
  'card.guestHint': '登录后可收藏、评价、加购',
  'card.hot': '热卖',
  'card.officialShop': '官方旗舰店',
  'card.premium': '优质商品',
  'card.rateFail': '评价失败',
  'card.rated': '已评：',
  'card.reviews': '条评价',
  'card.shopDefault': '普通店铺',
  'card.shopPraise': '店铺好评',
  'card.tapStars': '点击星星评价',
  'category.dairy': '乳品饮品',
  'category.freshFruit': '生鲜水果',
  'category.grain': '谷物粮油',
  'category.localSpecialty': '地方特产',
  'common.loadFailed': '加载失败',
  'common.loading': '加载中…',
  'common.retry': '重试',
  'common.yes': '是',
  'common.no': '否',
  'common.remove': '移除',
  'common.back': '返回',
  'errorBoundary.title': '页面出了点问题',
  'errorBoundary.desc': '抱歉，当前页面遇到了意外错误。您可以尝试刷新页面或返回首页。',
  'errorBoundary.detail': '错误详情',
  'errorBoundary.reload': '刷新页面',
  'errorBoundary.goHome': '返回首页',
  'credit.crown': '皇冠',
  'credit.diamond': '钻石',
  'lang.enUS': 'English',
  'lang.zhCN': '中文',
  'network.offline': '网络已断开，请检查网络连接',
  'notFound.backHome': '返回首页',
  'notFound.desc': '抱歉，您访问的页面不存在',
  'star.1': '糟糕',
  'star.2': '较差',
  'star.3': '普通',
  'star.4': '良好',
  'star.5': '优秀',
};
